import api from '@/utils/api';

/**
 * Get all company options
 * @param {string} companyId - Query to filter companies
 * @param {string} optionId - The option id
 * @returns {Promise}
 */
const getCompanyOptionApi = (companyId, optionId) =>
  api.get(`company/${companyId}/option/${optionId}`);

export default getCompanyOptionApi;
